export const isEmbedded = () => {
  try {
    return globalThis.self !== globalThis.top
  } catch (e) {
    return true
  }
}
